import { Grid } from "@mui/material"
import { Link, useNavigate } from "react-router-dom"
import { Logo, TelegramIcon, XIcon } from "../assets"
import { socialLinks } from "./commons"

const Footer = () => {
  const history = useNavigate()
  // const location = useLocation()

  const navigateTo = (route: string) => {
    history(route)
  }

  // const isDefaultPath = location.pathname !== '/markets' && location.pathname !== '/rewards'
  return (
    <Grid container sx={{
      color: 'white',
      padding: '.5rem 2rem',
      alignItems: 'center',
      bottom: 0,
      width: '100%',
      position: 'absolute'
    }}>
      <Grid item container justifyContent={"flex-start"} xs={6}>
        <Logo style={{ maxWidth: '6rem', maxHeight: '3rem' }} onClick={() => navigateTo('')} />
      </Grid>
      <Grid item container xs={6} justifyContent={"flex-end"}>
        <Link to={socialLinks.twitter} target='_blank' style={{ display: 'grid', placeSelf: 'center' }}>
          <XIcon />
        </Link>
        <Link to={socialLinks.telegram} target='_blank' style={{ display: 'grid', placeSelf: 'center' }}>
          <TelegramIcon style={{marginLeft: '0.5rem'}}/>
        </Link>
      </Grid>
      
      {/* <div style={{ display: 'flex', gap: '1rem' }}>
        <Button onClick={() => navigateTo('')} size='large' variant='text' isSelected={location.pathname === '/' || isDefaultPath} sx={{ border: 0 }}> Portfolio </Button>
        <Button onClick={() => navigateTo('/markets')} size='large' variant='text' sx={{ border: 0 }} isSelected={location.pathname === '/markets'}> Markets </Button>
        <Button onClick={() => navigateTo('/rewards')} size='large' variant='text' sx={{ border: 0 }} isSelected={location.pathname === '/rewards'}> Rewards </Button>
      </div> */}
    </Grid>
  )
}

export default Footer